import { render, staticRenderFns } from "./AIMCreate.vue?vue&type=template&id=b8abbe1c&"
import script from "./AIMCreate.vue?vue&type=script&lang=js&"
export * from "./AIMCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports